

import VeryBadSmily from '!file-loader!../assets/smiley-rating-very-bad.svg'
import PoorSmily from '../assets/smiley-rating-poor.svg'
import MediumSmily from '../assets/smiley-rating-medium.svg'
import GoodSmily from '../assets/smiley-rating-good.svg'
import ExcellentSmily from '../assets/smiley-rating-excellent.svg'
import { Report, SmilyValueTypes } from '../smilyTypes'
import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'

type SmilyProps = Readonly<{
    smilyReport: Report
}>


export function Smily({ smilyReport }: SmilyProps) {

    const displaySmily = (smilyValue: SmilyValueTypes) => {

        switch (smilyValue) {
            case SmilyValueTypes.VERYBAD:
                return VeryBadSmily
            case SmilyValueTypes.POOR:
                return PoorSmily
            case SmilyValueTypes.MEDIUM:
                return MediumSmily
            case SmilyValueTypes.GOOD:
                return GoodSmily
            case SmilyValueTypes.EXCELLENT:
                return ExcellentSmily
            default:
                return ""
        }

    }
    return (
        <>
            <Card variant='outlined' sx={{ width: 400, height: 350, marginRight: "1.5rem", marginTop: "3.0rem" }}>
                <Typography variant="h6" sx={{ paddingTop: "0.5rem", paddingBottom: "0.25rem", marginLeft: '1rem' }}>
                    Satisfaction
                </Typography>
                <Divider sx={{ marginX: '1rem' }} />

                <Grid
                    container
                    spacing={0}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    height={150}
                    width="100%"

                    display="flex"
                >
                    <Grid item paddingTop="2.5rem">
                        <img src={displaySmily(SmilyValueTypes.EXCELLENT)} height={150} />
                    </Grid>
                </Grid>

                <CardContent sx={{ textAlign: "center", marginTop: "3rem" }}>
                    <Typography variant="h6" sx={{ color: "#555555" }}>
                        Score: {smilyReport.reportSummary.averageScore}
                    </Typography>

                </CardContent>
            </Card >
        </>

    )
}
